import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './assets/fonts/fonts.css';
import './theme/tokens.css';

// Force the light theme as the default for everyone. The app theme API reads
// its initial value from localStorage['theme']; when that key is empty it
// falls back to the OS `prefers-color-scheme`, so users on a dark OS would
// land on dark — even on the sign-in page, which renders before any in-app
// React code. We seed the key here, synchronously before the app boots.
//
// Rule: whenever no theme id is stored, pin it to 'custom-light'. An explicit
// choice (custom-light / custom-dark) is stored under the same key and is
// therefore respected; only the "no choice / OS-based" case is overridden.
// (Note: there is intentionally no one-shot guard flag — a guard made this
// stateful and silently stopped seeding once set, which is the bug that kept
// the dark theme sticking.)
const THEME_KEY = 'theme';
try {
  if (window.localStorage && !window.localStorage.getItem(THEME_KEY)) {
    window.localStorage.setItem(THEME_KEY, 'custom-light');
  }
} catch {
  // localStorage may be unavailable (private mode, etc.) — ignore.
}

ReactDOM.createRoot(document.getElementById('root')!).render(App);
